import { Reppl, RepplResponse } from './service';

export const canView = (
  repplRes?: RepplResponse
): repplRes is RepplResponse => {
  return !(
    !repplRes ||
    !repplRes.reppl ||
    (repplRes.reppl.draft &&
      repplRes.reppl.userRole !== '103' &&
      !repplRes.reppl.isOwner)
  );
};

export const canSubmitEpisode = (reppl?: Reppl) =>
  (reppl && !reppl.draft && reppl.type === 'OPEN') || reppl?.isOwner;

export const ROLES = {
  1: 'Starter',
  101: 'Starter',
  103: 'Editor',
  104: 'Official Creator',
};

export function isEditable(role: string) {
  const convertRole = Number(role);

  if (convertRole in ROLES) {
    return true;
  }

  return false;
}

export function isStarter(role: string) {
  const convertRole = Number(role);

  if ([1, 101].includes(convertRole)) {
    return true;
  }

  return false;
}

export function isEditor(role: string) {
  const convertRole = Number(role);

  if ([103].includes(convertRole)) {
    return true;
  }

  return false;
}

export function getEpisodeActionsByRole({
  role,
  isOwnerInCollectionPage = false,
}: {
  role: string;
  isOwnerInCollectionPage?: boolean;
}) {
  if (!isEditable(role)) return [];

  const starterActions = [
    'edit',
    'pin',
    'pick',
    'collections',
    'unlist',
    'unpublish',
  ];
  const editorActions = ['edit', 'pick', 'collections', 'unlist', 'unpublish'];
  let roleActions;

  if (isOwnerInCollectionPage) {
    roleActions = {
      1: [...starterActions, 'remove-collections'],
      101: [...starterActions, 'remove-collections'],
      103: [...editorActions, 'remove-collections'],
    };

    return roleActions[role];
  }

  roleActions = {
    1: starterActions,
    101: starterActions,
    103: editorActions,
  };

  return roleActions[role];
}
